export default function toTitleCase(str: string) {
  return str.replace(
    /(\w)(\w*)/g,
    function (text: string, p1, p2) {
      return p1.toUpperCase() + p2?.toLowerCase()
    }
  );
}